import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import { getCmdbObjectQueryLanguageUrl } from '@atlassian/jira-servicedesk-cmdb-rest-urls/src/common/constants/object.tsx';

type ObjectType = {
	globalId: string;
};

type ObjectsAQLSearchResponse = {
	values: ObjectType[];
};

const serviceIdField = 'Service ID';

export const fetchInsightId = async (
	workspaceId: string,
	readOnlySchemaId: number,
	serviceId: string,
): Promise<string> => {
	const qlQuery = `objectSchemaId = "${readOnlySchemaId}" and "${serviceIdField}" = "${serviceId}"`;

	// eslint-disable-next-line jira/js/no-jira-fetch
	const aqlSearchResponse: ObjectsAQLSearchResponse = await performPostRequest(
		getCmdbObjectQueryLanguageUrl(workspaceId, {
			includeAttributes: false,
			maxResults: 1,
		}),
		{
			body: JSON.stringify({
				qlQuery,
			}),
		},
	);
	const { values } = aqlSearchResponse;
	if (values.length !== 1) {
		throw new Error('Could not find object.');
	}
	return values[0].globalId;
};
